import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useRackOutplanting(nurseryId: string, rackId: string, enabled: boolean = true) {
  const { isPending, error, data } = useQuery({
    queryKey: ["rack-outplanting", nurseryId, rackId],
    queryFn: () => API.getRackOutplantingPrediction(nurseryId, rackId),
    enabled: enabled,
    staleTime: 5 * 60 * 1000,
    retry: false
  });

  return {
    isPending,
    error,
    data,
  };
}

export default useRackOutplanting;
